import React from 'react'
import type { Comment } from '../../types'
import { CHANNEL_WORDS } from '../../utils'
import type { FeedbackChannel } from '../../utils'
import styles from './feedback.module.sass'

const DOT_CLASS: Record<FeedbackChannel, string> = {
  coaching: styles.dotCoaching,
  workshop: styles.dotWorkshop,
}

// The channel's colour, the same as on the engagement cards.
export const ChannelDot = ({ channel }: { channel: FeedbackChannel }) => (
  <span className={`${styles.dot} ${DOT_CLASS[channel]}`} aria-hidden="true" />
)

const Quote = ({ comment }: { comment: Comment }) => (
  <figure className={styles.quote}>
    <blockquote className={styles.quoteText}>{`“${comment.text}”`}</blockquote>
    <figcaption className={styles.quoteMeta}>
      <ChannelDot channel={comment.channel} />
      {CHANNEL_WORDS[comment.channel].name}
    </figcaption>
  </figure>
)

// Stacked beside the word cloud (column), or side by side and wrapping (grid).
const LAYOUT_CLASS = { column: styles.quoteColumn, grid: styles.quoteGrid }

export const QuoteList = ({ quotes, layout }: { quotes: Comment[]; layout: keyof typeof LAYOUT_CLASS }) => {
  if (quotes.length === 0) return null

  const items = quotes.map((comment) => <Quote key={comment.id} comment={comment} />)
  return <div className={LAYOUT_CLASS[layout]}>{items}</div>
}
